"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBatchFinishedStatus = exports.getBatchLastStep = void 0;

var _activeStep = require("../store/ui/activeStep");

var _batch = require("../modules/SendingBatch/constants/batch.types");

var getBatchLastStep = function getBatchLastStep(_ref) {
  var _batch$defaultProduct;

  var batch = _ref.batch;

  if ((batch === null || batch === void 0 ? void 0 : batch.giftsCreationStatus) === _batch.BatchGiftsCreationStatus.Finished) {
    return _activeStep.GiftingFlowStep.Send;
  }

  if (batch !== null && batch !== void 0 && (_batch$defaultProduct = batch.defaultProduct) !== null && _batch$defaultProduct !== void 0 && _batch$defaultProduct.id) {
    return _activeStep.GiftingFlowStep.Messaging;
  }

  if (batch) {
    return _activeStep.GiftingFlowStep.Gift;
  }

  return _activeStep.GiftingFlowStep.Contacts;
};

exports.getBatchLastStep = getBatchLastStep;

var isBatchFinishedStatus = function isBatchFinishedStatus(_ref2) {
  var batch = _ref2.batch;
  return (batch === null || batch === void 0 ? void 0 : batch.giftsFinishedStatus) === _batch.BatchGiftsFinishedStatus.Finished;
};

exports.isBatchFinishedStatus = isBatchFinishedStatus;